import React, { useEffect, useRef } from 'react';
import '../css/home.css';

const LetterDrop = ({ text1, text2 }) => {
  const containerRef1 = useRef(null);
  const containerRef2 = useRef(null);

  useEffect(() => {
    const animateText = (text, containerRef) => {
      const letters = text.split('');
      containerRef.current.innerHTML = '';
      letters.forEach((letter) => {
        const span = document.createElement('span');
        span.className = 'letterDrop';
        span.style.animationDelay = `${Math.random() * 0.8 + 0.1}s`; // Random delay between 0.1s and 0.9s
        span.innerHTML = letter === ' ' ? '&nbsp;' : letter; // Handle spaces
        containerRef.current.appendChild(span);
      });
    };

    animateText(text1, containerRef1);
    animateText(text2, containerRef2);
  }, [text1, text2]);

  return (
    <h1>
      <div ref={containerRef1} className="letterDropContainer text-[18px]  md:text-[83px] lg:text-[80px] xl:text-8xl 3xl:text-10xl 2xl:text-9xl " aria-hidden="true"></div>
      <div ref={containerRef2} className="letterDropContainer text-xl md:text-[83px] lg:text-[80px] xl:text-8xl 3xl:text-10xl 2xl:text-9xl  " style={{marginTop:'30px'}}    aria-hidden="true"></div>
    </h1>
  );
};

export default LetterDrop;
